import { useEffect, useState } from "react"
import MainContentWrapper from "../../Components/MainContentWrapper"
import { getNotificationHistory } from "../../apis/BhuMeetTeams/Marketing/notifications"
import TableView from "../../ReusableComponents/TableView/TableView"
import { useNavigate } from 'react-router'
import DurationFilters from "../../features/Revenue/SubComponents/DurationFilters"
import dateFormat from "dateformat";
import NotificationHistoryFilter from "./NotificationFilter"

export const MarketingNotificationHistory = () => {
    const navigate = useNavigate()
    const [AllNotificationHistory, setAllNotificationHistory] = useState([])
    const [loading, setLoading] = useState(false)
    const [formattedDate, setFormattedDate] = useState('');

    const [filters, setFilters] = useState(() => {
        const savedFilters = localStorage.getItem('notificationHistory');
        return savedFilters ? JSON.parse(savedFilters) :
            {
                pageNumber: 1,
                pageSize: 15,
                count: 0,
                interval: 'all',
                fromDate: null,
                toDate: null

            };
    });

    const [openFilter, setOpenFilter] = useState(false)

    const durationOptions = [
        { id: 6, placeholder: "All", interval: "all" },
        { id: 1, placeholder: "Today", interval: "day" },
        { id: 2, placeholder: "This Week", interval: "week" },
        { id: 3, placeholder: "This Month", interval: "month" },
        { id: 4, placeholder: "This Year", interval: "year" },
        {
            id: 5,
            placeholder: "Custom",
            interval: "custom",
            cb: () => {
                console.log("Custom")
                setOpenFilter(true);
            },
        },

    ];
    const getFormattedFromAndToDate = (interval) => {
        let formattedDate = ''
        switch (interval) {
            case 'day':
                formattedDate = `Date: ${dateFormat(
                    filters.fromDate,
                    "dd/mm/yyyy "
                )}`
                break;
            case "week":
                const fromDateMinusOneDay = new Date(filters.fromDate);
                fromDateMinusOneDay.setDate(fromDateMinusOneDay.getDate() - 1);
                formattedDate = `Date: ${dateFormat(fromDateMinusOneDay, "dd/mm/yyyy ")} 
                to ${dateFormat(filters.toDate, "dd/mm/yyyy ")}`;
                break
            case "month":
            case "year":
                formattedDate = `Date: ${dateFormat(filters.fromDate, "dd/mm/yyyy ")} 
                to ${dateFormat(filters.toDate, "dd/mm/yyyy ")}`
                break;
            case "custom":
                formattedDate = `Date: ${dateFormat(filters.fromDate, "dd/mm/yyyy hh:MM TT ")} 
                to ${dateFormat(filters.toDate, "dd/mm/yyyy hh:MM TT")}`
                break;
            default:
                formattedDate = ''
        }

        setFormattedDate(formattedDate);

    }




    useEffect(() => {
        console.log(filters)
        getAllHistory()
    }, [filters.pageNumber, filters.fromDate, filters.toDate, filters.interval])

    useEffect(() => {
        localStorage.setItem('notificationHistory', JSON.stringify(filters))
    }, [filters])


    async function getAllHistory() {
        setLoading(true)
        console.log(filters)
        let getHistory = await getNotificationHistory(filters.pageNumber, filters.pageSize, filters.fromDate, filters.toDate, filters.interval)
        setAllNotificationHistory(getHistory.notificationsLogs)
        setLoading(false)
        setFilters({ ...filters, count: getHistory.count })
        getFormattedFromAndToDate(filters.interval)
        // console.log(getHistory)
    }


    return (
        <MainContentWrapper containerStyle={{}} header={`Notification History (${filters.count || 0})`} >

            <div style={{
                margin: "20px 0",
                height: "90%"
            }}>
                <div style={{ display: "flex", marginBottom: "10px", justifyContent: "space-between" }}>
                    <div>
                        <DurationFilters handleFilterChanged={(e) => {
                            // console.log(e)
                            setLoading(true)
                            setFilters((prev) => ({ ...prev,pageNumber:1, fromDate: e.fromDate, toDate: e.toDate, interval: e.interval }))

                        }}
                            interval={filters.interval}
                            isAdmin={true}
                            options={durationOptions} />
                    </div>
                    <div style={{ marginLeft: "10px", marginTop: "4px" }} className="date_section">
                        <span>{formattedDate}</span>
                    </div>

                </div>
                {openFilter &&

                    <NotificationHistoryFilter open={openFilter} onFilterChange={(e) => {
                        console.log(e)

                        setFilters((prev) => ({ ...prev,pageNumber:1, fromDate: e.fromDate, toDate: e.toDate, interval: !e.fromDate || !e.toDate ? e.interval || filters.interval : "custom" }))
                        setOpenFilter(false)
                    }}
                        filter={filters}
                        onClose={(e) => {
                            console.log(e)
                            if (!filters.fromDate || !filters.toDate) {
                                console.log("ALL")
                                setFilters((prev) => ({ ...prev, interval: "all" }))
                                setFormattedDate('')
                            }

                            setOpenFilter(false)
                        }} />
                }


                <TableView
                    showSrNo
                    notFoundMsg={"No logs available"}
                    loadingHeight={"240px"}
                    isLoading={loading}
                    onStateChange={async (changedState) => {
                        const { pageNumber } = changedState;
                        // console.log("pageNumber", pageNumber);
                        setFilters({ ...filters, pageNumber });

                    }}
                    onClickRow={(row) => {
                        // console.log(row)
                        navigate(`/notifications`, { state: row })
                    }}
                    columns={[
                        { Header: "Sent By", accessor: "sent_by_name", width: "15%" },

                        { Header: "Notification Message", accessor: "notificationtoshow", width: "50%" },
                        { Header: "Time", accessor: "time", isDate: true, width: "12%" },

                    ]}

                    data={AllNotificationHistory}

                    tableContainerHeight={"100%"}
                    hidePagination={false}
                    headerStyle={{ zIndex: 0 }}
                    count={filters.count}
                    pageSize={filters.pageSize}
                    pageNumber={filters.pageNumber}

                />

            </div>

        </MainContentWrapper>
    )
}


